import { toast } from 'react-toastify'

const toastify = (store) => (next) => (action) => {
  if (action.type === 'api/callFailed') {
    // toast.error(action.payload || 'Error')
  }
  // Return the result so the dispatch chain preserves the promise the downstream
  // (api) middleware returns — callers rely on `dispatch(apiCallBegan(...)).then(...)`.
  return next(action)
}

export default toastify
